import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import { BUSINESS_API_PREFIX } from '../constants';
import { countEventService } from '../../events/countEvent';

export const updateMemberProfile = async ({ field, source = '' }: { field: string; source?: string }) => {
    try {
        const data = await axios.put(`${BUSINESS_API_PREFIX}/member/profile`, {
            field,
        });

        countEventService({ metric: 'update_member_profile', status: 'success', source });

        return data;
    } catch (error) {
        logger.error(error as any, { flow: 'updateMemberProfile' });
        countEventService({ metric: 'update_member_profile', status: 'fail', source });
        throw error;
    }
};

export default updateMemberProfile;
